pm.AnimationTransaction = cc.Class.extend({
    sequence: [],
    spawn: [],

    ctor: function () {
        this.sequence = [];
        this.spawn = [];
    },

    addPart: function () {
        if(this.spawn.length > 0)
            this.sequence.push(cc.spawn(this.spawn));

        this.spawn = [];
    },

    addAnimationToPart: function (target, animation, animationCallback, args) {
        var sequenceAnimation = target.getAnimation(animation, animationCallback, args);
        if (sequenceAnimation)
            this.spawn.push(cc.targetedAction(target.sprite.getSprite(), sequenceAnimation));
    },
});